import { ENABLE_BIG_TOP_THEME } from './bigTopRollout.js';
import { THEME_IDS } from './themeIds.js';

/**
 * Returns the user's registered theme preference.
 *
 * Today: pilot master switch only.
 * Future (dormant):
 *   const stored = window.localStorage.getItem('appThemeId');
 *   if (stored && themeRegistry[stored]) return stored;
 *   // or: return profile.themeId from API
 *
 * @returns {import('./themeIds.js').THEME_IDS[keyof import('./themeIds.js').THEME_IDS]}
 */
export function getRegisteredThemeId() {
  if (ENABLE_BIG_TOP_THEME) {
    return THEME_IDS.BIG_TOP;
  }

  return THEME_IDS.DEFAULT;
}
